<template>
    <div class="scrollableArea">

        <navigator :product="reservation.product" v-if="!$route.meta.reschedule"></navigator>

        <filters :availableResources="availableResources" :availableDurations="availableDurations" v-on:filterChanged="filterChanged" :filters="filters"></filters>

        <div class="container-fluid scrollThis" v-if="events.length > 0">
            <!-- <div class="col-sm-12"> -->
                <single-day v-for="dayGroup in eventsGroupedByDay" :key="dayGroup.date" :product="getReservationSelectedProduct" :group="dayGroup"></single-day>
            <!-- </div> -->
        </div>

        <div v-if="loadingEvents" class="dark fs-larger font-weight-600 text-center mt-4">
            <loader></loader>
        </div>

        <div class="dark fs-large text-center font-weight-600 mt-4" v-if="!loadingEvents && filteredEvents.length == 0">
            No events found
        </div>

    </div>
</template>

<script>
import navigator from './Availability/Navigator'
import filters from './Availability/Filters'
import singleDay from './Availability/SingleDay'
import Loader from '@/tools/loaders/loader1'

import {mapGetters, mapActions} from 'vuex'

export default {
    data: function() {
        return {
            events: [],
            loadingEvents: false,
            filters:{
                dateRange: [
                    moment().startOf('day').format('YYYY-MM-DD'),
                    moment().add(7, 'days').endOf('day').format('YYYY-MM-DD')
                ],
                resourceId: null,
                duration: null,
            },
        }
    },
    created: function() {
        // if coming with product id on the url
        if(this.$route.params.id){
            // this.refreshAccountData().then(response => {{
                this.getReservation.event.product.id = this.$route.params.id
                this.getEvents();
            // }})
        } else {

            if(this.reservation.product == null || !this.selectedProductId){
                //if page refreshed

                this.$router.push('/reservation');
            } else {

                this.getEvents();
            }

        }


    },
    computed: {
        ...mapGetters([
            'getReservation',
            'getReservationSelectedProduct',
            'account'
        ]),
        reservation: function(){
            return this.getReservation;
        },
        selectedProductId: function() {
            if(this.getReservation.product && this.getReservation.product.id){
                return this.getReservation.product.id
            } else if(this.getReservation.event && this.getReservation.event.product && this.getReservation.event.product.id){
                return this.getReservation.event.product.id
            } else {
                return false
            }
        },
        availableResources: function() {
            let resources = [];
            let allEvents = this.events;

            for (let event of allEvents) {
                if(event.product.resources){
                    for (let resource of event.product.resources){

                        let addResource = true;

                        for (let storedResource of resources){
                            if(storedResource.id && storedResource.id == resource.id){
                                addResource = false;
                            }
                        }

                        //the above is because comapring with indexOf was not successfull because of proto object.

                        if(addResource){
                            resources.push(resource);
                        }


                    }
                }
            }


            return resources;
        },
        availableDurations: function() {
            let durations = [];
            let allEvents = this.events;

            for (let event of allEvents) {
                if(durations.indexOf(event.product.duration) == -1){
                    durations.push(event.product.duration)
                }
            }


            return durations;
        },
        filteredEvents: function() {
            let filteredEvents = this.events

            //data range
            // if(this.filters.dateRange){
            //     filteredEvents = filteredEvents.filter(event => {
            //         // console.log('filtering: ',event.end, this.filters.dateRange[0].format("DD-MM-YY hh:mm"), this.filters.dateRange[1].format("DD-MM-YY hh:mm"));
            //         // console.log('result', moment(event.end).isBetween(this.filters.dateRange[0], this.filters.dateRange[1]));
            //         return moment(event.end).isBetween(moment(this.filters.dateRange[0]).startOf('day'), moment(this.filters.dateRange[1]).endOf('day'))
            //     })
            // }

            return filteredEvents
        },
        eventsGroupedByDay: function() {
            let eventsToGroup = this.filteredEvents;
            let groupedArr = [];

            for(let event of eventsToGroup){
                let currentEventDate = moment(event.start).format('YYYY-MM-DD');

                //if groupArr is empty, create first group
                if(groupedArr.length == 0){
                    groupedArr.push({
                        date: currentEventDate,
                        eventIds: [event.id],
                        events: [event]
                    })
                } else {
                    //the next events
                    let createNewGroup = true;
                    for(let group of groupedArr){
                        //if event happens on the same day as this group
                        if(currentEventDate == group.date){
                            createNewGroup = false;
                            group.eventIds.push(event.id)
                            group.events.push(event)
                        }
                    }

                    if(createNewGroup){
                        groupedArr.push({
                            date: currentEventDate,
                            eventIds: [event.id],
                            events: [event]
                        })
                    }
                }

            }

            groupedArr.sort(function compare(a, b) {
                if (moment(a.date).diff(b.date) < 0) {
                    return -1;
                }
                if (moment(a.date).diff(b.date) > 0) {
                    return 1;
                }
                // a must be equal to b
                return 0;
            })

            return groupedArr;

        }
    },
    methods:{
        ...mapActions([
            'refreshAccountData'
        ]),
        getEvents: function() {
            this.loadingEvents = true
            let response = axios.get('/api/booking/ProductAvailability', {
                params: {
                    supplierId: this.account.supplierId,
                    productId: this.selectedProductId,
                    dtStart: moment(this.filters.dateRange[0]).format("YYYY-MM-DD HH:mm:ss"),
                    dtEnd: moment(this.filters.dateRange[1]).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                }
            }).then(response => {
                this.loadingEvents = false
                console.log(response);
                if (response && response.status === 200 && response.data) {
                    this.events = response.data
                } else {
                    this.events = []
                }
            }).catch(error => {
                this.loadingEvents = false
                this.events = []
            })
        },
        filterChanged: function(filters){
            this.filters = filters
            this.getEvents()
        }
    },
    components:{
        navigator,
        filters,
        singleDay,
        Loader
    }
}
</script>

<style lang="scss">
.scrollableArea{
    display: flex;
    height: 94vh;
    flex-direction: column;

    .scrollThis{
        overflow: auto;
    }
}
</style>



// WEBPACK FOOTER //
// Availability.vue?273343b2